import type { DetailedHTMLProps, TextareaHTMLAttributes } from 'react';

const TextArea = (
  props: DetailedHTMLProps<
    TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  >,
) => <textarea {...props} />;
export default TextArea;
